const s = "_input_1nys4_1", i = "_htmlSize_1nys4_22", n = "_isBoolean_1nys4_86", _ = "_isSwitch_1nys4_133", t = "_isDisabled_1nys4_154", e = "_isInvalid_1nys4_158", o = "_shake_1nys4_1", a = {
  input: s,
  htmlSize: i,
  isBoolean: n,
  isSwitch: _,
  isDisabled: t,
  isInvalid: e,
  shake: o
};
export {
  a as default,
  i as htmlSize,
  s as input,
  n as isBoolean,
  t as isDisabled,
  e as isInvalid,
  _ as isSwitch,
  o as shake
};
//# sourceMappingURL=input.module.less.js.map
